import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { ChaletSection } from "@/components/ChaletSection";
import { DecorSection, ContactSection, Footer } from "@/components/Sections";
import { Toaster } from "@/components/ui/sonner";
import { CHALETS } from "@/data/chalets";

const Home = () => {
    return (
        <div className="App">
            <Header />
            <main>
                <Hero />
                <section id="chales" data-testid="chales-intro" className="pt-16 lg:pt-24 bg-[#FDFBF7]">
                    <div className="max-w-7xl mx-auto px-6 lg:px-12">
                        <p className="uppercase text-xs font-bold tracking-[0.2em] text-[#8B5A2B] mb-4">
                            Nossas acomodações
                        </p>
                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#1B231A] max-w-2xl">
                            Cinco refúgios únicos, uma só essência: você e a natureza
                        </h2>
                        <p className="mt-6 text-base leading-relaxed text-[#3E4C3D] max-w-2xl">
                            Cada chalé foi desenhado para oferecer privacidade absoluta, conforto de alto padrão e
                            uma conexão verdadeira com a mata de Ouro Preto. Escolha o seu e reserve em poucos cliques.
                        </p>
                    </div>
                </section>
                {CHALETS.map((chalet, i) => (
                    <ChaletSection key={chalet.id} chalet={chalet} index={i} />
                ))}
                <DecorSection />
                <ContactSection />
            </main>
            <Footer />
            <Toaster position="top-center" />
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
